@if (label()) {
  <label [for]="id()" class="block text-sm font-medium mb-1" style="color:var(--talos-ink)">
    {{ labelText() }}@if (isRequired()) {<span class="text-talos-accent ml-0.5">*</span>}
  </label>
}
<div class="relative">
  <select
    #selectEl
    [id]="id()"
    class="w-full appearance-none border rounded py-2.5 pl-3 pr-10 text-sm focus:outline-none bg-[var(--talos-bg)] transition-colors text-talos-ink"
    [class.border-talos-ink/18]="!invalid()"
    [style.border-color]="invalid() ? 'var(--talos-accent)' : null"
    [disabled]="isDisabled()"
    (change)="onChange($event)"
    (blur)="onBlur()"
  >
    <option value="" disabled>{{ placeholder() }}</option>
    @for (opt of options(); track opt.value) {
      <option [value]="opt.value" [disabled]="opt.disabled ?? false">{{ opt.label }}</option>
    }
  </select>
  <span class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
    <lucide-icon [img]="ChevronDownIcon" [size]="15" color="rgb(var(--talos-ink-rgb) / 0.4)"></lucide-icon>
  </span>
</div>
@if (hint() && !invalid()) {
  <span class="block text-xs mt-1" style="color:rgb(var(--talos-ink-rgb) / 0.4)">{{ hint() }}</span>
}
@if (invalid() && errorMessage()) {
  <app-field-message type="error" [message]="errorMessage()" />
}
